import ToggleZoomOverlay from './ToggleZoomOverlay';

export default ToggleZoomOverlay;
